import DeleteAction from './actions/delete';
import SwapSeatsAction from './actions/swap';

// These actions are required in different files
// So they can be used in rendering or selection
const Actions = [
    {
        name: 'delete',
        label: 'ticket.common.action.delete',
        component: DeleteAction
    },
    {
        name: 'swap',
        label: 'attendees.actions.swap',
        component: SwapSeatsAction,
        displayed: (event, showSwap) => Boolean(event && event.isRealSeatingNoSessions() && showSwap),
        disabled: (attendees, showSwap = true) => {
            if (!showSwap) {
                return true;
            }

            // Some attendees were invited by a partner
            if (attendees.some(attendee => attendee.partner)) {
                return true;
            }

            return attendees.some(attendee => {
                let booking = attendee.booking;
                // isGA is a getter on newer models
                return booking && booking.isGA;
            });
        },
        onMouseOver: function(attendees, update) {
            if (this.disabled(attendees)) {
                this.label = 'attendees.actions.errors.isGASeatedSmall';
                update();
            }

            // Some attendees were invited by a partner
            if (attendees.some(attendee => attendee.partner)) {
                this.label = 'attendees.actions.errors.isPartnerInvitationSmall';
                update();
            }
        },
        onMouseOut: function(attendees, update) {
            if (this.disabled(attendees)) {
                this.label = 'attendees.actions.swap';
                update();
            }
        }
    }
];

export default Actions;

export const FilteredActions = ({ event, showSwap = true, actions = null }) => {
    let filteredAction = Actions.filter(action => (action.displayed ? action.displayed(event, showSwap) : true));
    if (!actions) {
        return filteredAction;
    }

    return filteredAction.filter(action => actions.includes(action.name));
};
